export type CsvCell = string | number | null | undefined

/** Prefixes a spreadsheet would evaluate as a formula. Dimension values come from customer traffic. */
const FORMULA_PREFIXES = ['=', '+', '-', '@', '\t', '\r']

const NEEDS_QUOTING = /[",\r\n]/

/** Byte order mark, so Excel reads the file as UTF-8 instead of guessing the local codepage. */
export const UTF8_BOM = '\uFEFF'

function escapeCell(cell: CsvCell): string {
  if (cell == null) {
    return ''
  }

  if (typeof cell === 'number') {
    return Number.isFinite(cell) ? String(cell) : ''
  }

  const guarded = FORMULA_PREFIXES.some((prefix) => cell.startsWith(prefix)) ? `'${cell}` : cell

  return NEEDS_QUOTING.test(guarded) ? `"${guarded.replaceAll('"', '""')}"` : guarded
}

/** Serializes rows to RFC 4180 CSV. */
export function toCsvContent(rows: CsvCell[][]): string {
  return `${UTF8_BOM}${rows.map((row) => row.map(escapeCell).join(',')).join('\r\n')}`
}
